<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-hidden px-2.5 gap-x-5 grid grid-cols-2"
    >
      <div class="flex flex-col gap-y-2 overflow-y-auto">
        <ul class="flex items-center gap-x-1">
          <li class="w-1 bg-green-700 rounded-md h-3">&nbsp;</li>
          <strong>乘客信息</strong>
        </ul>
        <div
          class="bg-gray-100 rounded-lg p-2.5 flex flex-wrap gap-x-5 gap-y-2"
        >
          <c_cell title="乘客姓名" :value="state.info?.name" />
          <c_cell title="联系电话" :value="state.info?.name" />
          <c_cell title="类型">
            <c_status
              arrName="Meeting_Pickup_Car_Type"
              :key="state.info?.pickup_type"
              :value="state.info?.pickup_type"
            />
          </c_cell>
          <c_cell title="航班/车次" :value="state.info?.name" />
          <c_cell title="出发">
            <text class="text-xs text-gray-400">{{
              $dayjs(state.info?.departure_time).format("YYYY-MM-DD HH:mm")
            }}</text>
            <text class="ml-2">{{ state.info?.departure_name }}</text>
          </c_cell>
          <c_cell title="到达">
            <text class="text-xs text-gray-400">{{
              $dayjs(state.info?.arrival_time).format("YYYY-MM-DD HH:mm")
            }}</text>
            <text class="ml-2">{{ state.info?.arrival_name }}</text>
          </c_cell>
        </div>
        <ul class="flex items-center gap-x-1 mt-2">
          <li class="w-1 bg-green-700 rounded-md h-3">&nbsp;</li>
          <strong>接送信息</strong>
        </ul>
        <ul class="grid grid-cols-2 gap-y-2">
          <el-form-item
            label="接客时间"
            prop="c_reception_time"
            :rules="[
              { required: true, message: '请选择接客时间', trigger: 'blur' },
            ]"
          >
            <div class="grid items-center gap-x-2 grid-cols-2">
              <el-date-picker
                v-model="state.model.c_reception_date"
                type="date"
                placeholder="接客日期"
                value-format="YYYY-MM-DD"
                class="!w-full"
              />
              <el-time-picker
                v-model="state.model.c_reception_time"
                placeholder="时间"
                value-format="HH:mm:ss"
                format="HH:mm"
                class="!w-28"
                :save-on-blur="false"
              />
            </div>
          </el-form-item>
          <el-form-item
            label="接客地点"
            prop="send_place"
            :rules="[
              { required: true, message: '请选择接客地点', trigger: 'blur' },
            ]"
          >
            <!--来程到达地选择-->
            <el-select
              v-model="state.model.reception_place"
              filterable
              allow-create
              default-first-option
              placeholder="接客地点"
              :clearable="false"
            >
              <el-option
                v-for="option in state.jsdd_data"
                :key="option.name"
                :label="option.name"
                :value="option.name"
              ></el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadJsdd()"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="预计送达"
            prop="c_estimate_send_time"
            :rules="[
              { required: true, message: '请选择送达时间', trigger: 'blur' },
            ]"
          >
            <div class="grid items-center gap-x-2 grid-cols-2">
              <el-date-picker
                v-model="state.model.c_estimate_send_date"
                type="date"
                placeholder="送达日期"
                value-format="YYYY-MM-DD"
                class="!w-full"
              />
              <el-time-picker
                v-model="state.model.c_estimate_send_time"
                placeholder="时间"
                value-format="HH:mm:ss"
                format="HH:mm"
                class="!w-28"
                :save-on-blur="false"
              />
            </div>
          </el-form-item>
          <el-form-item
            label="送达地点"
            prop="reception_place"
            :rules="[
              { required: true, message: '请输入送达地点', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.send_place"></el-input>
          </el-form-item>
        </ul>
        <el-form-item label="接送说明">
          <el-input
            v-model="state.model.pickup_intro"
            type="textarea"
            :autosize="{
              minRows: 4,
            }"
          ></el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item
          prop="meeting_car_id"
          :rules="[{ required: true, message: '请选择车辆', trigger: 'blur' }]"
          label-position="left"
          inline-message
          :show-message="!state.model.meeting_car_id"
          class="!mb-0 car-form-item"
        >
          <template #label>
            <ul class="flex items-center gap-x-1" style="margin-left: -8px">
              <li class="w-1 bg-green-700 rounded-md h-3">&nbsp;</li>
              <strong>选择车辆</strong>
              <c_cell
                v-if="state.model.meeting_car_id"
                class="ml-2"
                title="已选车辆"
                :value="state.car_number"
              />
            </ul>
          </template>
        </el-form-item>
        <el-card
          v-for="car in state.car_data"
          :key="car.id"
          :shadow="state.model.meeting_car_id == car.id ? '' : 'hover'"
          class="mb-2"
          :style="{
            'box-shadow':
              state.model.meeting_car_id == car.id
                ? '0 0 5px var(--el-color-primary)'
                : '',
          }"
          @click="
            state.model.meeting_car_id = car.id;
            state.car_number = car.number;
          "
        >
          <div class="flex gap-x-2 items-center">
            <c_Avatar :size="10" :title="car.driver_name?.slice(0, 1)" />
            <div class="flex-1 flex flex-col gap-y-2">
              <ul class="flex gap-x-1 items-center">
                <strong>{{ car.driver_name }}</strong>
                <el-icon class="ml-5"><phone /></el-icon>
                <text>{{ car.driver_phone }}</text>
                <el-icon class="ml-5"><OfficeBuilding /></el-icon>
                <text>{{ car.driver_company }}</text>
              </ul>
              <ul class="flex gap-x-1 items-center text-xs">
                <li
                  class="bg-gray-100 rounded p-2 whitespace-nowrap flex items-center gap-x-1"
                >
                  <el-image
                    :src="require('@/assets/images/car.png')"
                    class="!w-3"
                  />
                  {{ car.number + "/" + car.name + "/" + car.d_car_type_name }}
                </li>
                <li class="bg-blue-100 rounded p-2 whitespace-nowrap">
                  {{ car.passenger_capacity + "人" }}
                </li>
                <li
                  class="bg-gray-100 rounded p-2 whitespace-nowrap flex items-center gap-x-1"
                >
                  <el-icon><Calendar /></el-icon>
                  {{ car.service_date_start + " ~ " + car.service_date_end }}
                </li>
              </ul>
              <c_cell v-if="car.intro" title="说明" :value="car.intro" />
            </div>
            <el-popover
              placement="left"
              trigger="click"
              width="fit-content"
              :disabled="car.task_count <= 0"
            >
              <template #reference>
                <div
                  class="text-center cursor-pointer"
                  @click.stop="onLoadTask(car)"
                >
                  <strong
                    class="cursor-pointer"
                    :class="car.task_count ? ' text-blue-500' : ''"
                  >
                    {{ car.task_count || 0 }}
                  </strong>
                  <ul class="text-xs text-gray-500">
                    当日任务
                  </ul>
                </div>
              </template>
              <div class="flex flex-col gap-y-1">
                <div
                  v-for="item in car.task_list"
                  :key="item"
                  class="flex gap-x-2 whitespace-nowrap bg-gray-100 text-xs rounded items-center p-2"
                >
                  <el-icon><Clock /></el-icon>
                  {{
                    $dayjs(item.reception_time).format("HH:mm") +
                    " ~ " +
                    $dayjs(item.estimate_send_time).format("HH:mm")
                  }}
                  <c_status
                    arrName="Meeting_Pickup_Car_Type"
                    :value="item.type"
                  />
                  {{ item.name }}
                  {{ item.transport_no }}
                  {{ item.reception_place + " ~ " + item.send_place }}
                </div>
              </div>
            </el-popover>
          </div>
        </el-card>
      </div>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        确定派车
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_service_transport_pickup_detail,
  meeting_service_transport_pickup_arrange,
  meeting_service_transport_pickup_getMeetingCarTaskList,
} from "@/http/meetingservice";
import { data_getMeetingCar, dic_getPickupPlace } from "@/http/data";
import { post_response } from "@/utils/funcs";
import { dayjs } from "element-plus";
export default {
  props: {
    id: Number,
    meeting_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoadJsdd();
      if (props.id) {
        meeting_service_transport_pickup_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.info = data;
            state.model = {
              id: data.id,
              meeting_id: props.meeting_id,
              c_reception_date: dayjs(data.arrival_time).format("YYYY-MM-DD"),
              c_reception_time: dayjs(data.arrival_time).format("HH:mm:ss"),
              c_estimate_send_date: dayjs(data.arrival_time).format(
                "YYYY-MM-DD",
              ),
            };
            data_getMeetingCar({
              limit: 0,
              meeting_id: props.meeting_id,
              is_get_task_count: 1,
              service_date: dayjs(data.arrival_time).format("YYYY-MM-DD"),
            }).then((res) => {
              if (res.status == 200) {
                const { list } = res.data?.data || {};
                state.car_data = list;
              }
            });
          }
        });
      }
    });

    //获取接送地点
    const onLoadJsdd = () => {
      dic_getPickupPlace().then((res) => {
        if (res.status == 200) state.jsdd_data = res.data.data;
      });
    };

    //获取车辆当日任务
    const onLoadTask = (car) => {
      if (car.task_count > 0 && !car.task_list?.length > 0) {
        meeting_service_transport_pickup_getMeetingCarTaskList({
          meeting_car_id: car.id,
          service_date: dayjs(state.info?.arrival_time).format("YYYY-MM-DD"),
        }).then((res) => {
          if (res.status == 200) {
            car.task_list = res.data.data;
          }
        });
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.reception_time =
            state.model.c_reception_date + " " + state.model.c_reception_time;
          state.model.estimate_send_time =
            state.model.c_estimate_send_date +
            " " +
            state.model.c_estimate_send_time;

          //倒查接送地点
          const d_pickup_place_reception = state.jsdd_data.find(
            (w) => w.name == state.model?.reception_place,
          );

          if (d_pickup_place_reception) {
            state.model.d_pickup_place_reception_id =
              d_pickup_place_reception.id;
          }

          meeting_service_transport_pickup_arrange(state.model).then((res) => {
            post_response(res, () => {
              setTimeout(() => {
                emit("close", true);
              }, 500);
            });
          });
        }
      });
    };
    return { state, formDom, onLoadJsdd, onSubmit, onLoadTask };
  },
};
</script>

<style lang="scss">
.car-form-item {
  .el-form-item__error--inline {
    padding-top: 0 !important;
  }
}
</style>
